import React from 'react';
import './housedetails2sidebar.scss'

const HouseDetails2Sidebar = () => {

	const handleScrollToContact = () => {
		const section = document.getElementById("contact-section");

		if (section) {
			section.scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		}
	};

	return (
		<aside className="HouseDetails2Sidebar">

			{/* 🔹 BOOKING CARD */}
			<div className="HouseDetails2Sidebar-booking-card">

				<div className="HouseDetails2Sidebar-pricing">
					<p className="HouseDetails2Sidebar-label">Price per Night</p>
					<h3>₹2,500*<span>/night</span>{" "} <small>(Upto 5 people*)</small></h3>
				</div>

				{/* 🔹 QUICK INFO */}
				<div className="HouseDetails2Sidebar-info">
					<p>👨‍👩‍👧 Up to 5 Guests</p>
					<p>⏰ Flexible Check-in</p>
					<p>🕒 Check-in: <strong>11:00 AM</strong></p>
					<p>🕙 Check-out: <strong>10:00 AM</strong></p>
				</div>

				{/* 🔹 BUTTONS */}
				<div className="HouseDetails2Sidebar-action-buttons">
					<button
						className="HouseDetails2Sidebar-btn-book"
						onClick={handleScrollToContact}
					>
						Check Availability
					</button>

					<a
						className="contact-owner-btn"
						href="tel:+919049928292"
					>
						📞 Call Owner
					</a>
				</div>

				{/* 🔹 OWNER PROFILE */}
				<div className="HouseDetails2Sidebar-agent-info">
					<img
						src="https://randomuser.me/api/portraits/men/45.jpg"
						alt="Owner"
						className="owner-img"
					/>

					<div>
						<p className="owner-name">Nikit Alagi</p>
						<a
							href="tel:+919049928292"
							className="owner-call"
						>
							+91 9049928292
						</a>
					</div>
				</div>

			</div>

			{/* 🔹 LOCATION CARD */}
			<div className="HouseDetails2Sidebar-map-card">

				<div className="HouseDetails2Sidebar-map-header">
					<h3>Location</h3>
					<p>Saiful, Solapur (Near Bijapur Road)</p>
				</div>

				<div className="HouseDetails2Sidebar-map-view">
					{/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.544108687257!2d75.90447!3d17.617048200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d996df8cc59f%3A0xc0cd9b162c3ceaf6!2sRefresh%20Inn%20Touch%20Wood!5e1!3m2!1sen!2sin!4v1774763476750!5m2!1sen!2sin" width="600" height="450"  style={{ border: 0 }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
					<iframe
						title="Property Location Map"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.544108687257!2d75.90447!3d17.617048200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d996df8cc59f%3A0xc0cd9b162c3ceaf6!2sRefresh%20Inn%20Touch%20Wood!5e1!3m2!1sen!2sin!4v1774763476750!5m2!1sen!2sin"
						width="600"
						height="450"
						style={{ border: "0" }}   // ✅ fixed
						allowFullScreen={true}
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					/>
				</div>

			</div>

		</aside>
	);
};

export default HouseDetails2Sidebar;